import { PERMISSION_MODULES } from "./permissions";

export const ANALYTICS_TABS = [
  {
    label: "Visualization",
    value: "visualization",
    module: PERMISSION_MODULES.VISUALIZATION,
  },
  { label: "Process", value: "process", module: PERMISSION_MODULES.PROCESS },
  { label: "Limits", value: "limits", module: PERMISSION_MODULES.LIMITS },
  { label: "Batches", value: "batches", module: PERMISSION_MODULES.BATCHES },
  { label: "Reports", value: "reports", module: PERMISSION_MODULES.REPORT },
  // { label: "Audit Trail", value: "audit-trail" },
  // { label: "Genealogy", value: "genealogy" },
  {
    label: "Dashboard",
    value: "dashboard",
    module: PERMISSION_MODULES.DASHBOARD,
  },
];
